export default __webpack_public_path__ + "static/PromptIconTwelve-892fabe813cbc3f228e1c77dfa44f552.png";